import React from 'react';
import styled from '@emotion/styled';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const StyledSocialButton = styled.a`
  width: 45px;
  height: 45px;
  border-radius: 22.5px;
  border: none;
  margin: 0;
  text-decoration: none;
  cursor: pointer;
  text-align: center;
  box-shadow: 0 2px 15px 0 rgba(171,171,171,0.50);
  display: flex;
   align-items: center;
   justify-content: center;
`;

const SocialButton = ({ icon, className, link, ...props }) => (
  <StyledSocialButton {...props} className={className} href={link}>
    <FontAwesomeIcon icon={icon} />
  </StyledSocialButton>
);

export default SocialButton;
